<div
  class="rs-panel-big rs-bg-c2 rs-margin-bottom4-m clearfix"
  *ngIf="amountAsNumber > 0"
>
  <p class="rs-tit2 rs-padding-bottom1">
    {{ 'bills.redesign.overview.balanceCard.totalToPay' | translate }}
  </p>
  <p>
    <px-currency-amount
      [amount]="amount"
      [amountClass]="'rs-price-sm'"
    ></px-currency-amount>
    {{ 'bills.cover.vatInclusiveWithSlash' | translate }}
  </p>
  <ng-container
    *ngIf="
      billingDocuments.length === 1 &&
        !hasSliceDetailsLinkedToBillingDocument &&
        unassignedFinancialTransactionsList.length === 0;
      else cardVersionB
    "
  >
    <p
      class="{{ singleDocumentPaymentTextColor }}"
      data-cy="singleDocumentPaymentText"
    >
      <i
        class="rs-status-icon"
        aria-hidden="true"
        *ngIf="singleDocumentPaymentTextHasIcon"
      ></i>
      {{ singleDocumentPaymentText }}
    </p>
    <span data-cy="versionA"></span>
    <my-bill-promise-of-payment-container
      [billingAccount]="billingAccount"
      [hasInstalmentPlan]="hasInstalmentPlan"
      [billingTransactions]="billingTransactions"
      *ngIf="showPromiseOfPayment"
    >
    </my-bill-promise-of-payment-container>
    <my-bill-pay-button-container
      [billingAccount]="billingAccount"
      [billingTransactions]="billingTransactions"
    ></my-bill-pay-button-container>
  </ng-container>

  <ng-template #cardVersionB>
    <ng-container *ngIf="openStatusInvoiceList?.length > 0">
      <ng-container
        *ngFor="let date of objectKeys(openStatusInvoiceListByDueDate)"
      >
        <p
          class="{{
            openStatusInvoiceListByDueDate[date].textColor
          }} rs-padding-bottom1"
          *ngIf="openStatusInvoiceListByDueDate[date].paymentText"
        >
          <i
            class="rs-status-icon"
            aria-hidden="true"
            *ngIf="openStatusInvoiceListByDueDate[date].hasIcon"
          ></i>
          {{ openStatusInvoiceListByDueDate[date].paymentText }}
        </p>
        <p class="rs-font-pxB rs-padding-bottom1">
          {{ openStatusInvoiceListByDueDate[date].monthYear }}
        </p>
        <my-bill-slice-invoice-item
          [invoicesByDate]="openStatusInvoiceListByDueDate[date]"
          [sliceDetailsNumber]="sliceDetailsNumber"
          [hasOpenStatus]="true"
        ></my-bill-slice-invoice-item>
      </ng-container>
    </ng-container>

    <ng-container *ngIf="ongoingStatusInvoiceList?.length > 0">
      <p class="rs-status rs-success">
        <i class="rs-status-icon" aria-hidden="true"></i>
        {{ 'bills.redesign.overview.balanceCard.paymentOngoing' | translate }}
      </p>
      <ng-container
        *ngFor="let date of objectKeys(ongoingStatusInvoiceListByMonth)"
      >
        <p class="rs-font-pxB rs-padding-bottom1">{{ date }}</p>
        <my-bill-slice-invoice-item
          [invoicesByDate]="ongoingStatusInvoiceListByMonth[date]"
          [sliceDetailsNumber]="sliceDetailsNumber"
        ></my-bill-slice-invoice-item>
      </ng-container>
    </ng-container>

    <ng-container *ngIf="overdueStatusInvoiceList?.length > 0">
      <p class="rs-status rs-error">
        <i class="rs-status-icon" aria-hidden="true"></i>
        {{ 'bills.redesign.overview.balanceCard.paymentOverdue' | translate }}
      </p>
      <ng-container
        *ngFor="let date of objectKeys(overdueStatusInvoiceListByMonth)"
      >
        <p class="rs-font-pxB rs-padding-bottom1">{{ date }}</p>
        <my-bill-slice-invoice-item
          [invoicesByDate]="overdueStatusInvoiceListByMonth[date]"
          [sliceDetailsNumber]="sliceDetailsNumber"
        ></my-bill-slice-invoice-item>
      </ng-container>
    </ng-container>

    <ng-container *ngTemplateOutlet="unassignedContent"></ng-container>
    <div
      class="rs-me"
      *ngIf="unassignedFinancialTransactionsList.length > 0"
    ></div>
    <span data-cy="versionB"></span>
    <my-bill-promise-of-payment-container
      [billingAccount]="billingAccount"
      [hasInstalmentPlan]="hasInstalmentPlan"
      [billingTransactions]="billingTransactions"
      *ngIf="showPromiseOfPayment"
    >
    </my-bill-promise-of-payment-container>
    <lib-generic-message-box
      [messageType]="messageBoxTypeInfo"
      id="messageBoxTypeInfoOngoingPayment"
      [showCross]="false"
      *ngIf="shouldShowOngoingMessage()"
    >
      <ng-container Title>{{
        'bills.redesign.overview.balanceCard.infoMessage.titleOngoingPayment'
          | translate
      }}</ng-container>
      <p Content>
        {{
          'bills.redesign.overview.balanceCard.infoMessage.msgOngoingPayment'
            | translate
        }}
      </p>
    </lib-generic-message-box>
    <my-bill-pay-button-container
      [billingAccount]="billingAccount"
      [billingTransactions]="billingTransactions"
    ></my-bill-pay-button-container>
  </ng-template>
</div>
<div
  class="rs-panel-big rs-bg-c2 rs-margin-bottom4-m clearfix"
  *ngIf="amountAsNumber < 0"
>
  <p class="rs-tit2 rs-padding-bottom1" data-cy="balanceAmountInYourFavor">
    {{ 'bills.redesign.overview.balanceCard.inYourFavor.title' | translate }}
  </p>
  <p>
    <px-currency-amount
      [amount]="amountAsAbsoluteValue"
      [amountClass]="'rs-price-sm'"
    ></px-currency-amount>
    {{ 'bills.cover.vatInclusiveWithSlash' | translate }}
  </p>
  <p
    data-cy="balanceAmountInYourFavorDescription"
    *ngIf="unassignedFinancialTransactionsList.length === 0"
  >
    {{ inYourFavorDescription | translate }}
  </p>
  <div
    class="rs-me"
    *ngIf="unassignedFinancialTransactionsList.length > 0"
  ></div>
  <ng-container *ngTemplateOutlet="unassignedContent"></ng-container>
</div>
<ng-template #unassignedContent>
  <ng-container *ngIf="unassignedFinancialTransactionsList.length > 0">
    <p class="rs-font-pxB rs-padding-bottom1">
      {{
        'bills.redesign.overview.balanceCard.unassignedTransactionMainTitle'
          | translate
      }}
    </p>
    <ng-container *ngFor="let invoice of unassignedFinancialTransactionsList">
      <div class="rs-flex-row" data-cy="unassignedFinancialTransaction">
        <div class="rs-flex-column">
          <p class="rs-txt-details">
            {{
              'bills.redesign.overview.balanceCard.unassignedTransactionItemTitle'
                | translate
            }}
          </p>
        </div>
        <div class="rs-flex-column rs-flex-shrink">
          <p class="rs-font-pxB rs-padding-bottom1">
            <px-currency-amount [amount]="invoice.amount"></px-currency-amount>
          </p>
        </div>
      </div>
    </ng-container>
  </ng-container>
</ng-template>
